import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {AccountLink} from 'src/components/links';

import {PLACE} from '../../constants';
import {
    accountSearchResultParentAccountsDataSelector,
    accountSearchResultParentAccountsResultSelector,
} from '../../slices/account-search-result-parent-accounts.slice';

type Props = {
    parentAccountId: number,
};

export const ParentAccountCell = ({parentAccountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultParentAccountsDataSelector);
    const result = useSelector(accountSearchResultParentAccountsResultSelector);

    const accountName = useMemo(() => result?.data[parentAccountId], [result, parentAccountId]);

    if (isLoading || loadingError || !accountName) {
        return null;
    }

    return (
        <AccountLink
            accountId={parentAccountId}
            place={PLACE}
            accountName={accountName}
        />
    );
};
